import { axFullfillment } from '../../AxiosFactory'

/* Get Orka Two Shipment Details */
const getTwoShipment = async () => {
  const res = await axFullfillment.get('/fulfillment/orders/')
  return res.data.data
}

export { getTwoShipment }
